import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Collapse } from 'antd';
const { Panel } = Collapse;
import 'antd/lib/collapse/style/css';

function Home(props) {
  const [matters,setMatters] = useState(props.matters);
  const {openAll, hightLightClass} = props;
  const changeDayMatter = (e,i) => {
    let newList = matters.map((item,id) => {
        if(item.children && Number(i) === id){
            item.children.map((ele,key) => {
              key = key + '';
                if (openAll) {
                  if(!e.includes(key)){
                    ele.close = true;
                  } else {
                    ele.close = false;
                  }
                } else {
                  if (Number(e) === Number(key)) {
                    ele.close = false;
                  } else {
                    ele.close = true;
                  }
                }
                return ele;
            })
        }
        return item;
    })
    setMatters(
        newList
    )
  }
  const changeYearMatter = (e) => {

    
    let newList = matters.map((item,id) => {
      if(item.children && Number(e) === id){
          item.children.map((ele,key) => {
              if (openAll) {
                ele.close = false;
              }
              return ele;
          })
      } else {
        
      }
      return item;
    })
    
    setMatters(
        newList
    )
  }
  const genDayExtra = (item, hasContent = true) => {
    let openStatusHtml = '';
    if(hasContent){
      openStatusHtml = <i className={`iconfont icon-open-close ${item.close ? 'icon-add-bold' : 'icon-minus-bold'}`} />;
    }else{
      openStatusHtml = <></>;
    }
    
    return (
      <div className={`matter-day-title ${!hasContent && 'matter-day-title_no-data'}`}>
        <div className="l">
            <div className="icon-calendar-wrap">
            </div>
            <span className="day">{item.day}</span>
        </div>
        <div className={`r ${item.close || (item.desc == '' && item.cover_img == null) ? 'close-style' : ''}`}>
          <span className={`title ${item.close ? '' : hightLightClass}`}>{item.title}</span>
          {openStatusHtml}
        </div>
      </div>
    );
  };
  const loopMatter = () => {
    return function fn(children) {
      return children.map((e, i) => {
        if (e.children) {
          return (
            <Panel header={e.year} key={i} className="">
                <Collapse onChange={(e) => {changeDayMatter(e,i)}} className="day-wrap" key={i} defaultActiveKey={openAll ? e.children.map((item, index) => {return index;}) : "0"} accordion={!openAll}>
                    {fn(e.children)}
                </Collapse>
            </Panel>
          );
        } else if(e.cover_img || e.desc) {
          return (
            <Panel key={i} className="" extra={genDayExtra(e)} showArrow={false} >
              {
                e.cover_img &&
                <div className="img-box">
                    <img src={e.cover_img} alt="" className="img"/>
                </div>
              }
              {
                e.desc &&
                <div className="text-pre-wrap matter-text-content">
                    {e.desc}
                </div>
              }
            </Panel>
          );
        }else{
            return genDayExtra(e, false);
        }
      });
    };
  };
  const resetData = () => {
      let newMatters = matters.map((item,key) => {
        switch (openAll) {
          case true:
            item.children.map((ele,id) => {
              ele.close = false;
              return ele;
            });
            break;
          case false:
            item.children.map((ele,id) => {
              if (id == 0) {
                ele.close = false;
                return ele;
              } 
              ele.close = true;
              return ele;
            });
            break;
        }
        return item;
      })
      
      setMatters(
        newMatters
      )
  }
  const bindTitle = () => {
    $('body').on('.memorabilia-title','click',function () {
      if($(this).hasClass(hightLightClass)) {
        $(this).removeClass(hightLightClass)
      }else{
        $(this).addClass(hightLightClass)
      }
    })
  }
  useEffect(() => {
    resetData();
    bindTitle();
  },[])
  return (
      <div className="matters-container">
          <Collapse accordion className="year-wrap" defaultActiveKey="0" onChange={(e) => {changeYearMatter(e)}} destroyInactivePanel={openAll ? true : false}>
            {loopMatter()(matters)}
          </Collapse>
      </div>
      );
}
class Matters {
  constructor(options) {
    this.defaultOptions = {
      openAll: false,
      hightLightClass: '',
    };
    this.options = Object.assign(this.defaultOptions, options);
  }
  init() {
    const domContainer = document.querySelector('.matters_container');
    ReactDOM.render(<Home {...this.options}/>, domContainer);
    if(this.options.initCb && typeof this.options.initCb === 'function')  {
      this.options.initCb();
    }
  }
}

window.Matters = Matters;
